import React, { Fragment } from 'react'
import AriaLive from '~/components/Aria/Live'
import GeolocationWrapper from '~/components/Geolocation'
import GoaffproScript from '~/components/Goaffpro/Script'
import KlaviyoOnsiteScript from '~/components/Klaviyo/OnsiteScript'
import LayoutWrapperClubDiscount from '~/components/Layout/ClubDiscount'
import { useBuyXGetOne } from '~/hooks/components/use-buy-x-get-one'
import { useOutdatedBundleDetection } from '~/hooks/components/use-outdated-bundle-detection'
import { useUrlPromoCodes } from '~/hooks/components/use-promo-codes'
import { loadAwinMasterTag } from '~/services/awin/client'

const LayoutWrapper = ({ children }) => {
  loadAwinMasterTag()
  useBuyXGetOne()
  useOutdatedBundleDetection()
  useUrlPromoCodes()

  return (
    <Fragment>
      {children}
      <LayoutWrapperClubDiscount />
      <GeolocationWrapper />
      <KlaviyoOnsiteScript />
      <GoaffproScript />
      <AriaLive />
    </Fragment>
  )
}

export default LayoutWrapper
